import useBackendClient from "@/client";
import useToast from "@/hooks/useToastNotification";
import { Campaign, CampaignInput } from "@/modules/Offers/types/types";
import { ref } from "vue";

const campaigns = ref<Campaign[]>([]);

export default function useCampaigns(gameId: string, versionId: string) {
  const { client } = useBackendClient();
  const { toastError } = useToast();

  async function getCampaigns() {
    try {
      const { data } = await client.get<Campaign[]>(`/app/${gameId}/version/${versionId}/campaigns`);
      campaigns.value = data;
    } catch (err) {
      toastError({ detail: "An error occurred while fetching campaigns.", summary: "Error", life: 3000 });
    }
  }

  async function createCampaign(campaign: CampaignInput) {
    const { name, purchaseLimit } = campaign;
    try {
      const { data } = await client.post<Campaign>(`/app/${gameId}/version/${versionId}/campaigns`, {
        name,
        purchaseLimit,
      });
      campaigns.value = [...campaigns.value, data];
      return data;
    } catch (err) {
      toastError({ detail: "An error occurred while creating the campaign.", summary: "Error", life: 3000 });
    }

    return null;
  }

  async function updateCampaign(campaign: CampaignInput) {
    const { id, name, purchaseLimit } = campaign;
    try {
      const { data } = await client.put<Campaign>(`/app/${gameId}/version/${versionId}/campaigns/${id}`, {
        name,
        purchaseLimit,
      });
      campaigns.value = campaigns.value.map((c) => (c.id === id ? data : c));
    } catch (err) {
      toastError({ detail: "An error occurred while updating the campaign.", summary: "Error", life: 3000 });
    }
  }

  async function deleteCampaign(campaignId: string) {
    try {
      await client.delete(`/app/${gameId}/version/${versionId}/campaigns/`, { data: { campaignIds: [campaignId] } });
      campaigns.value = campaigns.value.filter((c) => c.id !== campaignId);
    } catch (err) {
      toastError({ detail: "An error occurred while deleting the campaign.", summary: "Error", life: 3000 });
    }
  }

  return { campaigns, getCampaigns, createCampaign, updateCampaign, deleteCampaign };
}
